<template>
  <div class="max-w-7xl mx-auto py-2 md:py-6 sm:px-6 lg:px-4 grid grid-cols-2 gap-4">
    <section class="p-4 col-span-2">
      <colors-component></colors-component>
    </section>
    <section class="p-4 mt-6 col-span-2">
      <fonts-component></fonts-component>
    </section>
    <help-center-component :url="this.helpCenter.kn_branding_url" class="pl-3"></help-center-component>
  </div>
</template>

<script>
import ColorsComponent from "@/views/customization/branding/ColorsComponent";
import FontsComponent from "@/views/customization/branding/FontsComponent";
import HelpCenterComponent from "@/views/common/HelpCenterComponent";
import helpcenter from "@/services/helpcenter/links";

/* Personalización › Diseño: color corporativo y tipografías. */
export default {
  name: "DesignComponent",
  components: {
    ColorsComponent,
    FontsComponent,
    HelpCenterComponent,
  },
  setup() {
    return {
      helpCenter: helpcenter,
    }
  },
}
</script>
